import "./slider.scss";
import Glide from '@glidejs/glide'

(($) => {
    function initTestimonialsSlider() {
        console.log("Testimonials slider OK");

        const testimonials = document.querySelector(".glide.testimonials")
        let glide 
        if(testimonials.querySelectorAll(".glide__slide").length == 2 ) {

            glide = new Glide(testimonials, {
                type: 'slider',
                gap: 0,    
                perView: 2,
                dragThreshold: false,
                slideWidth: 500,
                breakpoints: {
                    1200: {
                        dragThreshold: true,
                        perView: 1,
                        autoplay: 3000,
                        peek: {
                            before: 150,
                            after: 150
                        }
                    },
                    767: {
                        perView: 1,
                        autoplay: 3000,
                        peek: {
                            before: 100,
                            after: 100
                        }
                    },
                    640: {
                        perView: 1,
                        autoplay: 3000,
                        peek: {
                            before: 20,
                            after: 20
                        }
                    }
                }
            })
        } else {
            glide = new Glide(testimonials, {
                type: 'carousel',
                autoplay: 3000,
                gap: 0,    
                perView: 3,
                peek: {
                    before: 200,
                    after: 200
                },
                breakpoints: {
                    1600: {
                        perView: 2
                    },
                    1200: {
                        perView: 1
                    },
                    767: {
                        perView: 1,
                        peek: {
                            before: 100,
                            after: 100
                        }
                    },
                    640: {
                        perView: 1,
                        peek: {
                            before: 20,
                            after: 20
                        }
                    }
                }
            })
        }
        

        
        glide.mount()

    }
    if ($("body").hasClass("wp-admin")) {
        $(document).on("initTestimonialsSlider", initTestimonialsSlider);
    } else {
        $(document).ready(initTestimonialsSlider);
    }
})(jQuery);